<script setup lang="ts">

  // Idioma
  const { locale, t } = useI18n()

  const { clear } = useUserSession()
  const byhoursConnect = useCookie('byhours_connect')

  const links = ref([
    [
      {
        label: t('labels.user_zone.menu.reservas'),
        icon: 'i-lucide-building-2',
        to: `/${locale.value}/user-zone/bookings`
      },
      {
        label: t('labels.user_zone.menu.favoritos'),
        icon: 'i-heroicons-heart',
        to: `/${locale.value}/user-zone/favorites`
      },
      {
        label: t('labels.user_zone.menu.perfil'),
        icon: 'i-lucide-user-circle',
        to: `/${locale.value}/user-zone/profile`
      }
    ],
    [
      {
        label: t('labels.user_zone.menu.inicio'),
        icon: 'i-lucide-home',
        to: `/${locale.value}`
      },
      {
        label: t('labels.user_zone.menu.cerrarSesion'),
        icon: 'i-lucide-log-out',
        onClick: async() => {
          await clear()
          byhoursConnect.value = null
          navigateTo(`/${locale.value}`)
        }
      }
    ]
  ])

  // Actualizar titulo del enlace actual
  const route = useRoute()
  const currentLink = computed(() => {
    return links.value.flat().find((link) => 'to' in link && link.to === `${route.path}`)
  })

  const currentLinkLabel = useState('currentLinkLabel', () => currentLink.value?.label || t('labels.user_zone.menu.reservas'))
  currentLinkLabel.value = currentLink.value?.label || t('labels.user_zone.menu.reservas')
  watch(currentLink, (newValue) => {
    if(!newValue) return
    currentLinkLabel.value = newValue.label
  })

</script>

<template>
  
  <div class="sm:hidden">
    <UDropdownMenu
      :items="links"
      :ui="{
        content: 'w-48'
      }"
    >
      <UButton icon="i-lucide-menu" color="neutral" variant="link" />
    </UDropdownMenu>
  </div>

  <div class="hidden sm:flex flex-col gap-2">
    <UNavigationMenu orientation="vertical" color="neutral" :items="links" />
  </div>

</template>